import { getS3Image } from "./awsLib";

export function processAnswers(answers, interactions, UID) {

  return Promise.all(answers.map(async answer => {
    answer.author.avatarURL = await getS3Image(answer.author.UID);
    answer.date = new Date(answer.date);
    const now = new Date(Date.now() + answer.date.getTimezoneOffset()*60000);
    answer.time = Math.floor(
      (now - answer.date) / 1000 / 60 / 60 / 24 / 7
    );    
    let unit = ' wks ago';
    if (answer.time === 0) {
      answer.time = Math.floor(
        (now - answer.date) / 1000 / 60 / 60 / 24
      );
      unit = ' days ago';
    }
    if (answer.time === 0) {
      answer.time = Math.floor(
        (now - answer.date) / 1000 / 60 / 60
      );    
      unit = ' hrs ago';
    }
    if (answer.time === 0) {
      answer.time = Math.floor(
        (now - answer.date) / 1000 / 60
      );    
      unit = ' mins ago';
    }
    if (answer.time === 1)  {
      unit = unit.replace('s', '');
    }
    answer.time += unit
    answer.upVoted = false;
    answer.awarded = false;
    if (answer.author.UID === UID) {
      answer.awarded = true; // can't award your own comment -> set awarded
      answer.canDelete = true; // can delete flag
    }
    if (answer.answer_id in interactions) {
      if (interactions[answer.answer_id].includes('up'))
        answer.upVoted = true;
      if (interactions[answer.answer_id].includes('award'))
        answer.awarded = true;
    }
    // compute score
    let time = -Math.ceil(
      (now - answer.date) / 1000 / 60 / 60
    );

    let penalty = 1;
    if (answer.downs > 0)
      penalty = Math.min(answer.ups/answer.downs, 1)
    let interactivity = 1;
    if (answer.ups > 5 && answer.downs < answer.ups)
      interactivity = answer.ups+answer.downs;
    answer.score = (interactivity / (time + 0.15)) * penalty
    return answer
  }));
}
